import axios from "axios";
import { message } from "ant-design-vue";
// json文件映射 实际请求相对路径 匹配 本地json文件
const jsonMapping = new Map([
  ["/city", "city.json"],
  ["/monitor", "monitor.json"],
  ["/pdf", "OperationManual.pdf"]
]);

// 请求本地json数据
let TEST_REQUEST = axios.create({
  baseURL: "./static/",
  responseType: "json",
  validateStatus(status) {
    // 200 外的状态码都认定为失败
    return status === 200;
  }
});

// 拦截请求
TEST_REQUEST.interceptors.request.use(
  resqust => {
    console.log(`请求拦截 = ${resqust.baseURL}${resqust.url}`);
    let flag;
    for (let item of jsonMapping) {
      if (item[0] === resqust.url) {
        resqust.url = item[1];
        flag = true;
        break;
      }
    }
    if (!flag) {
      let jsonName;
      let arr = resqust.url.split(".");
      if (
        (arr.length > 1 && arr[arr.length - 1] !== "json") ||
        arr.length === 1
      ) {
        resqust.url = resqust.url + ".json";
      }
    }
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(resqust);
      }, 1000);
    });
  },
  err => {
    return Promise.reject(err);
  }
);

const testRequest = {
  // 测试本地数据用，测试的json文件可放在static/test文件夹
  test(url, params) {
    return TEST_REQUEST.get(url);
  },
  download(url, filename) {
    message.loading("文件下载中···");
    return TEST_REQUEST.get(url, {
      responseType: "blob"
    })
      .then(r => {
        const content = r.data;
        console.log("content", r.data);
        const blob = new Blob([content]);
        if ("download" in document.createElement("a")) {
          const elink = document.createElement("a");
          elink.download = filename;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          navigator.msSaveBlob(blob, filename);
        }
        message.success("下载成功");
      })
      .catch(r => {
        console.error(r);
        message.error("下载失败");
      });
  }
};

export default testRequest;



// WEBPACK FOOTER //
// ./src/utils/testRequest.js